import { render, staticRenderFns } from "./TransferToBeneficiaries.vue?vue&type=template&id=1f93c688&"
import script from "./TransferToBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./TransferToBeneficiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports